import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GetForm } from './modalForm';
const ReportCredentialsIssueModal = observer(_ref => {
  let trigger = _ref.trigger;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '516-ReportCredentialsIssueModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.cant_find_provider')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noLeftButton: true,
    noPadding: true,
    title: "Report Credentials Issue",
    trigger: trigger || defaultTrigger
  }, /*#__PURE__*/React.createElement(GetForm, null));
});
export default ReportCredentialsIssueModal;